import React, { useState, useEffect, useRef } from "react";
import { GoogleGenerativeAI } from "@google/generative-ai";
import Loader from "react-js-loader";
import Navbar from "../navbar/Navbar";
import "./Therapist.css";

const API_KEY = process.env.REACT_APP_API_KEY;
const genAI = new GoogleGenerativeAI(API_KEY);

const TypingAnimation = ({ color }) => (
  <div className="typing-animation">
    <Loader type="ping-cube" bgColor={color} color={color} size={70} />
  </div>
);

const Therapist = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const chatBoxRef = useRef(null);

  const handleSend = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setLoading(true);

    try {
      const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

      const prompt = `
You are a warm, calm, empathetic AI therapist. 
Respond directly to the user in a supportive and conversational tone.
Keep paragraphs short and use line breaks between ideas.

User: ${input}
Therapist:
`;

      const result = await model.generateContent(prompt);
      const response = await result.response;
      let aiMessage = await response.text();

      aiMessage = aiMessage.replace(/\*\*(.*?)\*\*/g, "$1");

      // short delay to feel natural
      await new Promise((resolve) => setTimeout(resolve, 600));

      setMessages((prev) => [...prev, { sender: "ai", text: aiMessage }]);
    } catch (error) {
      console.error("Error generating response:", error);
      setMessages((prev) => [
        ...prev,
        { sender: "ai", text: "Sorry, I had trouble responding just now. Let's try again." },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSend();
  };

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages, loading]);

  return (
    <>
      
      <div className="therapist-container">
        <h1 className="heading">Your AI Therapist</h1>

        <div ref={chatBoxRef} className="chat-box">
          {messages.length === 0 && !loading && (
            <p className="placeholder-text">
              🌸 Start a gentle conversation about how you’re feeling today.
            </p>
          )}

          {messages.map((msg, index) => (
            <div
              key={index}
              className={`message ${
                msg.sender === "user" ? "user-message" : "ai-message"
              }`}
            >
              {msg.text}
            </div>
          ))}

          {loading && <TypingAnimation color="#FF9F87" />}
        </div>

        <div className="input-container">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Type your message..."
            className="input-field"
          />
          <button onClick={handleSend} className="send-button">
            Send
          </button>
        </div>
      </div>
    </>
  );
};

export default Therapist;
